export default __webpack_public_path__ + "static/media/toStart.7693dd8d.svg";